import { Link } from 'react-router-dom';
import { categories } from '@/mocks/dramas';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-white hover:text-primary-400 transition-colors duration-200 mb-4"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-xl text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold whitespace-nowrap">
                香蕉影视
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              香蕉影视提供电视剧全集免费高清在线追剧，最新热播电视剧大全观看，不缓冲流畅秒开不卡顿，追剧必备平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">
              分类浏览
            </h4>
            <div className="flex flex-wrap gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 text-sm rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-white mb-4">
              关于我们
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/about"
                  className="text-background-400 hover:text-primary-400 transition-colors duration-200"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-400 hover:text-primary-400 transition-colors duration-200"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-background-400 hover:text-primary-400 transition-colors duration-200"
                  rel="nofollow"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-background-400 hover:text-primary-400 transition-colors duration-200"
                  rel="nofollow"
                >
                  隐私政策
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 香蕉影视. 本站内容仅供学习交流使用.
          </p>
          <p className="text-xs text-background-600">
            香蕉影视 - 追剧必备，快乐无限
          </p>
        </div>
      </div>
    </footer>
  );
}